import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { ClientService } from '../../services/client.service';
import { CLIENT_ACCESS, SYMPTOMS_DATA, BEHAVIOUR_DATA } from '../../util/drop_down.helper';
import { hasKey } from '../../util/object.util';
import { isString, sortByCreatedAt } from '../../util/utils';
import { getArrangementsValue, getLeaveCellText, getProperty, getServiceRefusedByText, yesOrNo } from '../../util/clientService.util';
import { FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../services/admin.service';
import { CellVisitService } from '../../services/cell-visit.service';
import { DiversionCentreService } from '../../services/diversion-centre.service';
import { CommunityPatrolService } from '../../services/community-patrol.service';

@Component({
	selector: 'app-client-diversion',
	templateUrl: 'client-diversion.component.html',
	styleUrls: ['client-diversion.component.scss']
})
export class ClientDiversionComponent implements OnInit {

	public id: string | null = null;
	public type: string | null = null;
	public clientId: string | null = null;
	public clientData;
	public diversionCenters;
	public cellVisits;
	public communityPatrols;
	public accessCommentList: { label: string, value: string, name: string }[] = CLIENT_ACCESS;
	public symptomsList: any[] = SYMPTOMS_DATA;
	public behaviourList: any[] = BEHAVIOUR_DATA;

	public helpers = {
		getArrangementsValue,
		yesOrNo,
		getLeaveCellText,
		getProperty,
		getServiceRefusedByText
	};

	// Admin edit wiring
	public timeInCtrl = new FormControl<string | null>(null);
	public checkoutAtCtrl = new FormControl<string | null>(null);
	public editReason: string = '';
	public modalRef?: NgbModalRef;
	public current: any;
	public pendingChanges: any = {};


	// Audit entries (admin-only)
	public audits: AuditEntry[] = [];
	private isAdmin: boolean = false;

	constructor(
		private clientService: ClientService,
		private route: ActivatedRoute,
		private _notifications: NotificationsService,
		private modalSvc: NgbModal,
		public adminService: AdminService,
		private cellVisitService: CellVisitService,
		private diversionCentreService: DiversionCentreService,
		private communityPatrolService: CommunityPatrolService,
	) {
	}

	ngOnInit(): void {
		// Track admin status for conditional audit loading
		this.adminService.user$.subscribe(usr => {
			this.isAdmin = (usr?.role === 'Admin');
		});
		this.id = this.route.snapshot.paramMap.get('id');
		this.type = this.route.snapshot.paramMap.get('type');
		this.clientId = this.route.snapshot.paramMap.get('clientId');
		this.route.params.subscribe({
			next: params => {
				if (hasKey(params, 'id') && isString(params.id) && hasKey(params, 'type') && isString(params.type) && hasKey(params, 'clientId') && isString(params.clientId)) {
					this.id = params.id;
					this.type = params.type;
					this.clientId = params.clientId;

					//#region get data
					this.clientService.clientSearchListing({ page: 1, limit: 10, search: '', listType: this.type, mainId: this.id, clientId: params.clientId, isCheckout: true }).subscribe({
						next: (divData: any) => {
							if (divData && divData.status) {
								let currentRowData = divData.data.rows.shift();
								if (currentRowData.diversionCenters && currentRowData.diversionCenters.length) {
									this.clientData = currentRowData;
									let currentData = currentRowData.diversionCenters.shift();
									this.diversionCenters = currentData;
									if (this.diversionCenters.clientObservationForms) {
										this.diversionCenters.clientObservationForms.map((itm) => {
											itm.clientCheck = new Date(itm.clientCheck);
										});
										sortByCreatedAt(this.diversionCenters.clientObservationForms);
									}
								}
								if (currentRowData.cellVisits && currentRowData.cellVisits.length) {
									this.clientData = currentRowData;
									let currentData = currentRowData.cellVisits.shift();
									this.cellVisits = currentData;
									if (this.cellVisits.clientObservationForms) {
										this.cellVisits.clientObservationForms.map((itm) => {
											itm.clientCheck = new Date(itm.clientCheck);
										});
										sortByCreatedAt(this.cellVisits.clientObservationForms);
									}
								}
								if (currentRowData.communityPatrols && currentRowData.communityPatrols.length) {
									this.clientData = currentRowData;
									let currentData = currentRowData.communityPatrols.shift();
									this.communityPatrols = currentData;
									if (this.communityPatrols.clientObservationForms) {
										this.communityPatrols.clientObservationForms.map((itm) => {
											itm.clientCheck = new Date(itm.clientCheck);
										});
										sortByCreatedAt(this.communityPatrols.clientObservationForms);
									}
								}
								// Set current record and seed controls
								const record = this.type === 'diversion' ? this.diversionCenters : this.type === 'cell' ? this.cellVisits : this.communityPatrols;
								this.current = record;
								this.seedControlsFromCurrent();
								this.loadAudits();
							} else {
								this._notifications.warn("ERROR", divData.message || "", {});
							}
						}
					})
					//#endregion

				}
			}
		});
	}

	itemBehaviour(selctedVal) {
		const behaviour = this.behaviourList.filter((itm) => {
			if (itm.value == selctedVal) {
				return itm.label;
			}
		}).shift();

		if (behaviour) {
			return behaviour.label;
		}

		return '';
	}

	itemSymptoms(selctedVal) {
		const symptom = this.symptomsList.filter((itm) => {
			if (itm.value == selctedVal) {
				return itm.label;
			}
		}).shift();

		if (symptom) {
			return symptom.label;
		}

		return '';
	}

	getLeaveCellComment(cellVisitRecord: any) {
		if (cellVisitRecord.isLeaveDiversion === 1) {
			return cellVisitRecord.leaveDiversionComment1;
		}

		if (cellVisitRecord.isLeaveDiversion === 4) {
			return cellVisitRecord.leaveDiversionComment2;
		}

		return '';
	}

	getLeaveDiversionComment(diversionRecord: any) {
		if (diversionRecord.isLeave === 1) {
			return diversionRecord.leaveComment1;
		}

		if (diversionRecord.isLeave === 4) {
			return diversionRecord.leaveComment2;
		}

		return '';
	}

	private seedControlsFromCurrent() {
		if (!this.current) { return; }
		// Use timeIn for check-in; set using datetime-local compatible value
		this.timeInCtrl.setValue(this.toLocalInput(this.current.timeIn));
		this.checkoutAtCtrl.setValue(this.toLocalInput(this.current.checkoutAt));
	}


	private toLocalInput(iso?: string | number | Date | null): string {
		if (!iso) return '';
		const d = new Date(iso);
		if (isNaN(+d)) return '';
		const pad = (n: number) => n.toString().padStart(2, '0');
		const yyyy = d.getFullYear();
		const mm = pad(d.getMonth() + 1);
		const dd = pad(d.getDate());
		const hh = pad(d.getHours());
		const mi = pad(d.getMinutes());
		return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
	}

	private toISO(local: string | null): string | undefined {
		if (!local) return undefined;
		const d = new Date(local);
		return isNaN(+d) ? undefined : d.toISOString();
	}

	private getServiceByType(type: string) {
		switch (type) {
			case 'cell':
			case 'cell-visit':
				return this.cellVisitService;
			case 'diversion':
			case 'diversion-centre':
				return this.diversionCentreService;
			case 'community':
			case 'community-patrol':
				return this.communityPatrolService;
			default:
				throw new Error('Unknown activity type: ' + type);
		}
	}

	openEditReasonAndSave(content: TemplateRef<any>) {
		const nextTimeInISO = this.toISO(this.timeInCtrl.value);
		const nextCheckoutISO = this.toISO(this.checkoutAtCtrl.value);
		
		// Normalize current values to ISO strings for comparison using timeIn
		const currentTimeInISO = this.current?.timeIn ? new Date(this.current.timeIn).toISOString() : null;
		const currentCheckoutISO = this.current?.checkoutAt ? new Date(this.current.checkoutAt).toISOString() : null;
		
		const changes: any = {};
		// Send as timeIn to update the check-in time on the backend
		if (nextTimeInISO && nextTimeInISO !== currentTimeInISO) changes.timeIn = nextTimeInISO;
		if (nextCheckoutISO && nextCheckoutISO !== currentCheckoutISO) changes.checkoutAt = nextCheckoutISO;
		
		if (!changes.timeIn && !changes.checkoutAt) { 
			this._notifications.info('INFO', 'No changes', {}); 
			return; 
		}
		const finalTimeIn = changes.timeIn ?? currentTimeInISO;
		const finalCheckoutAt = changes.checkoutAt ?? currentCheckoutISO;
		if (finalTimeIn && finalCheckoutAt) {
			if (new Date(finalCheckoutAt).getTime() < new Date(finalTimeIn).getTime()) {
				this._notifications.error('ERROR', 'Checkout must be at or after check-in', {});
				return;
			}
		}
		this.pendingChanges = changes;
		this.editReason = '';
		this.modalRef = this.modalSvc.open(content, { centered: true });
	}

	confirmEditSave() {
		const reason = (this.editReason || '').trim();
		if (reason.length < 5) { this._notifications.error('ERROR', 'Please enter at least 5 characters', {}); return; }
		const payload = { ...this.pendingChanges, reason };
		try {
			const svc: any = this.getServiceByType(this.type!);
			svc.update(this.id!, payload).subscribe({
				next: () => { this.modalRef?.close(); this._notifications.success('Updated', '', {}); this.reloadDetail(); },
				error: (e: any) => this._notifications.error('ERROR', e?.error?.message || 'Update failed', {})
			});
		} catch (err) {
			this._notifications.error('ERROR', (err as Error)?.message || 'Unknown error', {});
		}
	}

	reloadDetail() {
		if (!this.id || !this.type || !this.clientId) return;
		this.clientService.clientSearchListing({ page: 1, limit: 10, search: '', listType: this.type, mainId: this.id, clientId: this.clientId, isCheckout: true }).subscribe({
			next: (divData: any) => {
				if (divData && divData.status) {
					let currentRowData = divData.data.rows.shift();
					if (this.type === 'diversion' && currentRowData.diversionCenters?.length) {
						this.diversionCenters = currentRowData.diversionCenters.shift();
						this.current = this.diversionCenters;
					}
					if (this.type === 'cell' && currentRowData.cellVisits?.length) {
						this.cellVisits = currentRowData.cellVisits.shift();
						this.current = this.cellVisits;
					}
					if (this.type === 'community' && currentRowData.communityPatrols?.length) {
						this.communityPatrols = currentRowData.communityPatrols.shift();
						this.current = this.communityPatrols;
					}
					this.seedControlsFromCurrent();
					this.loadAudits();
				}
			},
			error: () => { /* ignore */ }
		});
	}

	private computeCheckoutByNameForCurrent(): string | null {
		try {
			switch (this.type) {
				case 'diversion':
					return getProperty(this.diversionCenters?.updatedDiversion, 'name') || null;
				case 'cell':
					return getProperty(this.cellVisits?.updatedCell, 'name') || null;
				case 'community':
					return getProperty(this.communityPatrols?.updatedCommunity, 'name') || null;
				default:
					return null;
			}
		} catch {
			return null;
		}
	}

	public checkoutByDisplay(): string | null {
		// Always compute from the latest record to reflect current updater
		return this.computeCheckoutByNameForCurrent();
	}

	// Load audits for the current record based on route params
	private loadAudits() {
		try {
			if (!this.isAdmin) { this.audits = []; return; }
			const type = this.type || this.route.snapshot.paramMap.get('type')!;
			const recordId = this.current?.id || this.route.snapshot.paramMap.get('id')!;
			if (!type || !recordId) { this.audits = []; return; }
			const svc: any = this.getServiceByType(type);
			if (!svc?.getAudits) { this.audits = []; return; }
			svc.getAudits(recordId).subscribe({
				next: (res: any) => {
					// Normalise varying API shapes
					if (Array.isArray(res)) { this.audits = res as AuditEntry[]; return; }
					if (res?.items && Array.isArray(res.items)) { this.audits = res.items as AuditEntry[]; return; }
					if (res?.data?.items && Array.isArray(res.data.items)) { this.audits = res.data.items as AuditEntry[]; return; }
					this.audits = [];
				},
				error: () => this.audits = []
			});
		} catch {
			this.audits = [];
		}
	}

	public formatChanges(c: any): string {
		
		// - JSON string
		if (!c) return '';
		let val: any = c;
		if (typeof val === 'string') {
			try { val = JSON.parse(val); } catch { /* keep as string */ }
		}
		const labelFor = (field: string): string => {
			const f = (field || '').toLowerCase();
			if (['timein','time_in','checkin','check_in'].includes(f)) return 'Check In';
			if (['checkoutat','checkout_at','checkout','check_out','check_out_at'].includes(f)) return 'Check Out';
			return field;
		};
		const fmtPair = (label: string, from: any, to: any) => `${label}: ${this.short(from)} → ${this.short(to)}`;
		const parts: string[] = [];
		// Case A: array of entries
		if (Array.isArray(val)) {
			for (const entry of val) {
				if (!entry) continue;
				if (Array.isArray(entry) && entry.length >= 3) {
					const [field, from, to] = entry;
					parts.push(fmtPair(labelFor(String(field)), from, to));
					continue;
				}
				if (typeof entry === 'object') {
					const field = entry.field || entry.name || entry.key || '';
					const from = entry.from ?? entry.old ?? entry.previous ?? (entry.value && entry.value.from);
					const to = entry.to ?? entry.new ?? entry.current ?? (entry.value && entry.value.to);
					if (field && (from !== undefined || to !== undefined)) {
						parts.push(fmtPair(labelFor(String(field)), from, to));
					}
				}
			}
			return parts.join(' | ');
		}
		// Case B: object with known keys
		if (typeof val === 'object') {
			const obj = val;
			const candidates: Array<[string, any]> = [
				['timeIn', obj.timeIn],
				['time_in', obj.time_in],
				['checkIn', obj.checkIn],
				['check_in', obj.check_in],
				['checkoutAt', obj.checkoutAt],
				['checkout_at', obj.checkout_at],
				['checkout', obj.checkout]
			];
			for (const [key, v] of candidates) {
				if (!v) continue;
				if (typeof v === 'object') {
					const from = v.from ?? v.old ?? v.previous ?? (Array.isArray(v) ? v[0] : undefined);
					const to = v.to ?? v.new ?? v.current ?? (Array.isArray(v) ? v[1] : undefined);
					parts.push(fmtPair(labelFor(key), from, to));
				} else if (Array.isArray(v) && v.length >= 2) {
					parts.push(fmtPair(labelFor(key), v[0], v[1]));
				}
			}
			// If nothing matched, attempt generic object diff format
			if (!parts.length) {
				try {
					for (const k of Object.keys(obj)) {
						const v = obj[k];
						if (v && typeof v === 'object' && ('from' in v || 'to' in v)) {
							parts.push(fmtPair(labelFor(k), (v as any).from, (v as any).to));
						}
					}
				} catch { /* ignore */ }
			}
			return parts.join(' | ');
		}
		// Case C: unknown primitive, just echo
		return String(val);
	}

	private short(v: any): string {
		if (!v) return '';
		const d = new Date(v);
		if (isNaN(+d)) return String(v);
		return this.formatDisplay(d);
	}

	private formatDisplay(value?: string | number | Date | null): string {
		if (!value) return '';
		const d = new Date(value);
		if (isNaN(+d)) return '';
		const pad = (n: number) => n.toString().padStart(2, '0');
		let hours = d.getHours();
		const minutes = pad(d.getMinutes());
		const ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12; if (hours === 0) hours = 12;
		const hh = pad(hours);
		const dd = pad(d.getDate());
		const mm = pad(d.getMonth() + 1);
		const yy = pad(d.getFullYear() % 100);
		return `${dd}/${mm}/${yy} ${hh}:${minutes} ${ampm}`;
	}

	private parseDisplay(str: string): Date | null {
		const m = str && str.trim().match(/^(\d{2})\/(\d{2})\/(\d{2})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
		if (!m) return null;
		const [_, dd, mm, yy, h, min, ap] = m;
		let hours = parseInt(h, 10);
		if (/PM/i.test(ap) && hours < 12) hours += 12;
		if (/AM/i.test(ap) && hours === 12) hours = 0;
		const year = 2000 + parseInt(yy, 10);
		const date = new Date(year, parseInt(mm, 10) - 1, parseInt(dd, 10), hours, parseInt(min, 10), 0, 0);
		return isNaN(+date) ? null : date;
	}
}

export interface AuditEntry {
  id: string;
	actorId?: string | number | null;
  actorName?: string | null;
  action: string;
  reason?: string | null;
  changedFields?: any | null;
  createdAt: string;
}
